import { convertTextToKebabCase } from "@app/shared/utility/convertTextToKebabCase";
import React, { useContext } from "react";
import { OutlineBadge, OutlineBadgeColor } from "@app/shared/OutlineBadge";
import { ProviderActionStatusEnum, ProviderBadgeStyle } from "@app/projects/enumerators";
import { ProviderActionStatusEnumToDisplay } from "@app/projects/utility";
import { UserContext } from "@app/user/UserContext";
import Roles from "@app/user/roles";

interface ProviderActionStatusBadgeProps {
    status: ProviderActionStatusEnum;
    badgeStyle: ProviderBadgeStyle;
    hideWhenNullActionStatus?: boolean;
    testId?: string;
}

const ACTION_STATUS_BADGE_COLORS: Record<ProviderActionStatusEnum, OutlineBadgeColor> = {
  [ProviderActionStatusEnum.FullyExcluded]: OutlineBadgeColor.Navy,
  [ProviderActionStatusEnum.FullyTargeted]: OutlineBadgeColor.Magenta,
  [ProviderActionStatusEnum.FullyTerminated]: OutlineBadgeColor.Charcoal,
  [ProviderActionStatusEnum.PartiallyExcluded]: OutlineBadgeColor.Plain,
  [ProviderActionStatusEnum.PartiallyTargeted]: OutlineBadgeColor.Plain,
  [ProviderActionStatusEnum.PartiallyTerminated]: OutlineBadgeColor.Plain,
  [ProviderActionStatusEnum.Unknown]: OutlineBadgeColor.Plain,
};

const ProviderActionStatusBadge: React.FC<ProviderActionStatusBadgeProps> = ({ status, badgeStyle, hideWhenNullActionStatus = false, testId }) => {
  // Hooks must run before any conditional return
  const userContext = useContext(UserContext);

  if (!status && hideWhenNullActionStatus) {
      return;
  }

  if ((status === ProviderActionStatusEnum.PartiallyTerminated || status === ProviderActionStatusEnum.FullyTerminated)
    && (!userContext.roles.includes(Roles.TERM_PROVIDER_ADMIN) && !userContext.roles.includes(Roles.TERM_PROVIDER_VIEWER))) {
    return;
  }

  const statusToDisplay = ProviderActionStatusEnumToDisplay(status);

  return (
      <>
          {badgeStyle === ProviderBadgeStyle.Outline &&
              <OutlineBadge
                  color={ACTION_STATUS_BADGE_COLORS[status] ?? OutlineBadgeColor.Plain}
                  testId={testId}
              >
                  {statusToDisplay}
              </OutlineBadge>
          }
          {badgeStyle === ProviderBadgeStyle.Dot &&
              <div className="provider-badge-dot">
                  <span className={`provider-badge-dot-circle provider-badge-dot-${convertTextToKebabCase(statusToDisplay)}`} />
                  <span>{statusToDisplay}</span>
              </div>
          }
      </>
  )
};

export default ProviderActionStatusBadge;